import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

/** Maps legacy /event-os/* and /pnl/* URLs to unified flat routes. */
export const LegacyPrefixedRedirect: React.FC = () => {
  const { pathname, search, hash } = useLocation();

  const flat = legacyPathToFlat(pathname);
  if (!flat) {
    return <Navigate to="/calendar" replace />;
  }

  return <Navigate to={`${flat}${search}${hash}`} replace />;
};

export function legacyPathToFlat(pathname: string): string | null {
  const match = pathname.match(/^\/(?:event-os|pnl)(\/.*)?$/);
  if (!match) return null;

  let suffix = match[1] ?? "";
  if (!suffix || suffix === "/") return "/calendar";

  suffix = suffix.replace(/\/events\/([^/]+)\/dashboard\b/, "/events/$1/overview");
  suffix = suffix.replace(/\/events\/([^/]+)\/logistics\b/, "/events/$1/budget");
  suffix = suffix.replace(/\/events\/([^/]+)\/workspace\/live\b/, "/events/$1/live");
  suffix = suffix.replace(/\/events\/([^/]+)\/workspace\/([^/]+)\b/, "/events/$1/live");
  suffix = suffix.replace(/\/events\/([^/]+)\/workspace\b/, "/events/$1/live");

  suffix = suffix.replace(/^\/artists\b/, "/directory/artists");
  suffix = suffix.replace(/^\/venues\b/, "/directory/venues");
  suffix = suffix.replace(/^\/contacts\b/, "/directory/contacts");

  suffix = suffix.replace(/^\/command-center\b/, "/events");
  suffix = suffix.replace(/^\/dashboard\b/, "/events");

  return suffix;
}

export const LegacyEventDashboardRedirect: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  if (!eventId) return <Navigate to="/events" replace />;
  return <Navigate to={`/events/${eventId}/overview`} replace />;
};
